﻿import { useEffect, useState } from "preact/hooks";

export default class KpiVisualiserContext {
    public static pageReference: DotNet.DotNetObject | null = null;

    public static entries: KPIRuntime[] = [];
    public static selectedEntry: string | null = null;
    public static workingHours: WorkingHour[] = [];

    public static async Localize(key: string): Promise<string | null> {
        if (KpiVisualiserContext.pageReference == null) {
            return null;
        }

        return await KpiVisualiserContext.pageReference.invokeMethodAsync<string>("JS_Localize", key);
    }

    public static GetWorkingHoursForDate(date: Date): WorkingHour | null {
        const dayNum = date.getDay();

        for (const wh of KpiVisualiserContext.workingHours) {
            if (wh.dayOfWeek === dayNum) {
                return wh;
            }
        }

        return null;
    }
}

export function useLocalized(localizationKey: string, defStr?: string) {
    const [str, setStr] = useState(defStr ?? "");

    useEffect(() => {
        KpiVisualiserContext.Localize(localizationKey)
            .then(s => {
                if (s != null) {
                    setStr(s);
                }
            });

    }, [KpiVisualiserContext.pageReference]);

    return str;
}
